<template>
    <div @click="selectGOC()" class="featured-goc">
        <div v-if="isLoading">
            <div class="spinner-container">
                <div class="spinner"></div>
            </div>
        </div>
        <img v-else :src="goc | getProductImage" class="lazyload featured-image"/>
        <p class="happybox-button white border">View {{ goc.category }} Collection</p>
    </div>
</template>


<script>
export default {
    props:{
        goc: Object,
    },
    computed:{
        isLoading(){
            if(this.goc && this.goc.collectionProducts && this.goc.collectionProducts.length > 0){
                return false;
            }

            return true
        },
        productImages(){
            if(this.goc && this.goc.collectionProducts && this.goc.collectionProducts.length > 0){
                return this.goc.collectionProducts.filter(x => x.images.length > 0).map(x => x.images[0].src);
            }

            return [];
        }
    },
    methods:{
        nextSlide(){
            this.$refs.flicking.next();
        },
        prevSlide(){
            this.$refs.flicking.prev();
        },
        selectGOC(){
            this.$emit("selectgoc",this.goc)
        }
    }

}
</script>

<style scoped>
  
    .featured-goc {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 1% 0;
        width: 20%;
        gap: 15px;
        align-items: center;
    }

    .spinner-container{
        height: 200px;
        min-height: unset;
    }

    .product-title{
        font-size: 1.15vw;
        font-weight: bold;
        margin: unset;
        padding: 0% 5%;
        width: 100%;
    }

    .featured-image{
        width: 100%;
        object-fit: cover;
    }

    .happybox-button{
        width: 90%;
        margin: unset;
        font-size: 0.9vw;
    }

    @media screen and (max-width: 767px) {
        .product-title{
            font-size: 3.5vw;
        }

        .featured-goc{
            padding: 5% 0%;
        }
        .happybox-button{
            font-size: 3vw;
        }
    }
</style>